var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "buy_svg__a",
    d: "M0 0h140v140H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.126 100.607H46.874c-1.63 0-2.964-1.884-2.964-3.514l2.964-43.49c0-1.632 1.333-2.996 2.963-2.996h6.1c-.288 0-.445 3.77-.45 5.868a1.973 1.973 0 00-.042.54c.008.164.026.293.054.446 0 .04 0 .07.01.12a2.968 2.968 0 003.23 2.665 2.952 2.952 0 002.66-3.23l-.014-.112c.01-.14.015-.13.015-.282 0-2.05.204-6 .576-6H78c.373 0 .577 3.95.577 6 0 .27.016.406.05.637-.01 1.51 1.142 2.75 2.68 2.9 1.63.16 3.082-1.08 3.24-2.707.05-.488.026-.76-.045-1.128-.014-2.037-.17-5.706-.45-5.706h6.1c1.63 0 2.963 1.364 2.963 2.995L96.08 97.1c0 1.63-1.338 3.515-2.968 3.515M69.78 33.435c7.307 0 13.03 10.097 13.03 22.987 0 .82-.662 1.49-1.48 1.49-.82 0-1.482-.664-1.482-1.483 0-10.858-4.61-20.028-10.07-20.028-5.457 0-10.068 9.17-10.068 20.024a1.482 1.482 0 01-2.963-.002c0-12.89 5.723-22.988 13.03-22.988M70 0C31.3 0 0 31.3 0 70s31.3 70 70 70 70-31.3 70-70S108.7 0 70 0",
    fill: "#717C87",
    fillRule: "evenodd"
  })));
}

export default SvgBuy;